import React, { useEffect, useState } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Process from "@/components/Process";
import About from "@/components/About";
import Services from "@/components/Services";
import CaravanServices from "@/components/CaravanServices";
import AddOns from "@/components/AddOns";
import Gallery from "@/components/Gallery";
import WhyChooseUs from "@/components/WhyChooseUs";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import Booking from "@/components/Booking";
import Footer from "@/components/Footer";
import PromoBanner from "@/components/PromoBanner";
import ThankYou from "@/components/ThankYou";

function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 },
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}

function usePromo() {
  const [promo, setPromo] = useState("");
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const p = params.get("promo");
      if (p) {
        const code = p.trim().toUpperCase();
        setPromo(code);
        sessionStorage.setItem("ddd_promo", code);
      } else {
        const stored = sessionStorage.getItem("ddd_promo");
        if (stored) setPromo(stored);
      }
    } catch (_e) {
      /* no-op */
    }
  }, []);
  return promo;
}

function App() {
  useReveal();
  const promo = usePromo();
  const [booking, setBooking] = useState(null);

  const handleBookingSuccess = (data) => {
    setBooking(data);
    window.scrollTo({ top: 0, behavior: "instant" });
  };

  if (booking) {
    return (
      <div className="App" data-testid="app-root">
        <Toaster theme="light" position="top-right" />
        <ThankYou booking={booking} onBack={() => setBooking(null)} />
      </div>
    );
  }

  return (
    <div className="App" data-testid="app-root">
      <Toaster
        theme="light"
        position="top-right"
        toastOptions={{
          style: {
            background: "#ffffff",
            color: "#0b0b14",
            border: "1px solid rgba(11,11,20,0.1)",
          },
        }}
      />
      <PromoBanner promo={promo} />
      <Navbar promo={promo} />
      <main className={promo ? "pt-10" : ""}>
        <Hero />
        <Process />
        <About />
        <Services />
        <CaravanServices />
        <AddOns />
        <Gallery />
        <WhyChooseUs />
        <Testimonials />
        <FAQ />
        <Booking promo={promo} onSuccess={handleBookingSuccess} />
      </main>
      <Footer />
    </div>
  );
}

export default App;
